import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/semiProducts';
import { get } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* getSemiProducts({ payload }) {
  try {
    const response = yield call(get, `/grid/production/semi_product/list?plantId=${payload.plantId}&dateFrom=${payload.dateFrom}&dateTo=${payload.dateTo}`);
    yield put(action.getSemiProductsSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getSemiProductsFail());
  }
}
